export const getStoredUserData = () => {
  try {
    return JSON.parse(localStorage.getItem("data") || "null");
  } catch (error) {
    return null;
  }
};

const normalizeToken = (token) => {
  if (!token || typeof token !== "string") return "";

  const trimmedToken = token.trim();
  if (!trimmedToken || trimmedToken === "undefined" || trimmedToken === "null") return "";

  return trimmedToken;
};

export const getAuthToken = () => {
  const userData = getStoredUserData();
  const rawStoredToken = localStorage.getItem("token");
  const storedToken = normalizeToken(rawStoredToken);

  if (rawStoredToken === null) {
    return "";
  }

  if (!storedToken && rawStoredToken) {
    const fallbackToken = normalizeToken(userData?.token);
    localStorage.removeItem("token");

    if (fallbackToken && !isTokenExpired(fallbackToken)) {
      localStorage.setItem("token", fallbackToken);
      return fallbackToken;
    }

    return "";
  }

  const tokens = [
    storedToken,
    normalizeToken(userData?.token),
  ].filter(Boolean);

  return tokens.find((token) => !isTokenExpired(token)) || tokens[0] || "";
};

export const isTokenExpired = (token = getAuthToken()) => {
  if (!token || token.split(".").length !== 3) return false;

  try {
    const base64Payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const paddedPayload = base64Payload.padEnd(base64Payload.length + (4 - base64Payload.length % 4) % 4, "=");
    const payload = JSON.parse(atob(paddedPayload));
    if (!payload.exp) return false;

    return Date.now() >= payload.exp * 1000;
  } catch (error) {
    return false;
  }
};

export const clearSessionAndRedirect = () => {
  localStorage.clear();
  window.location.href = "/signin?sessionExpired=true";
};

export const handleAuthError = (error) => {
  const status = error?.response?.status;

  if (status === 401 || status === 403) {
    clearSessionAndRedirect();
    return true;
  }

  return false;
};

export const handleAuthResponse = (response) => {
  if (response?.status === 401 || response?.status === 403) {
    clearSessionAndRedirect();
    return true;
  }

  return false;
};
